import React, { Component } from 'react';
import moment from 'moment';
import 'moment/locale/es';
import Autocomplete from 'react-autocomplete';
import _ from 'lodash';
import {IDPROCESO_MCDE } from '../../constants';


export default class DetalleEntregasLogistica extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isActive: 0,
      display: 'none',
      optionMotivo: '',
      observacion: '',
      historial: [],
      colaboradorCaja: '',
      colaboradores: [],
      colaboradoresSeleccionados: [],
      validarCampo:false,
    };
    this.cerrarModalVerDetalle = this.cerrarModalVerDetalle.bind(this);
    this.clickNuevaObservacion = this.clickNuevaObservacion.bind(this);
    this.clickComentar = this.clickComentar.bind(this);
    this.clickCancelar = this.clickCancelar.bind(this);
    this.changeSearchOptionMotivo = this.changeSearchOptionMotivo.bind(this);
    this.onChangeObservacionInput = this.onChangeObservacionInput.bind(this);
    this.traerColaboradores = this.traerColaboradores.bind(this);
    this.limpiarColaboradores = this.limpiarColaboradores.bind(this);
    this.limpiarInputs = this.limpiarInputs.bind(this);
  }

  componentWillReceiveProps(prop) {
    this.setState({ historial: prop.historial, colaboradores: prop.colaboradores });
  }

  onChangeObservacionInput(e) {
    this.setState({ observacion: e.target.value });
  }

  limpiarColaboradores() {
    this.props.limpiarColaboradores();
  }

  traerColaboradores(value) {
    this.props.traerColaboradores(value);
  }

  clickNuevaObservacion() {
    this.limpiarInputs();
    if (this.state.display === 'block') {
      this.setState({ display: 'none' });
    } else {
      this.setState({ display: 'block' });
    }
  }

  clickCancelar() {
    this.setState({ display: 'none'});
    this.limpiarInputs();
  }

  changeSearchOptionMotivo(e) {
    this.setState({ optionMotivo: e.target.value });
  }

  cerrarModalVerDetalle() {
    this.props.cerrarModalVerDetalle();
    this.setState({ display: 'none' });
    this.limpiarInputs();
  }

  clickComentar() {
    if(this.state.optionMotivo ==='' || this.state.observacion.length===0){
      this.setState({validarCampo:true});
    }else{
      this.setState({validarCampo:false});
      this.props.clickComentar({
        codColaborador: this.state.colaboradoresSeleccionados.map(item => item.id),
        codMotiHist: this.state.optionMotivo,
        obsEntrHist: this.state.observacion.replace(/\n/g, "<br />"),
      });
    }
  }
  ocultarComentario(){
    this.setState({ display: 'none' });
  }
  limpiarInputs(){
    this.setState({validarCampo:false,optionMotivo:'',  observacion: '', colaboradorCaja: '', colaboradoresSeleccionados: [] });
  }

  printcontent = (content)=>
  {
      return {__html:content};
  }

  renderInformacion() {
    return (
      <div>
        <header className='fdv-section-head'>
          <h5 className='fdv-section-title'>Información de entrega</h5>
        </header>
        <div className='card card-lg card-plain mb-3'>
          <div className='row' />
          <div className='row'>
            <div className='col-md-4'>
              <label className='labelInfo'>Transportista</label>
              <p>{this.props.entregasLogistica.tipTrans}</p>
            </div>
            <div className='col-md-4'>
              <label className='labelInfo'>Tipo de entrega</label>
              <p>{this.props.entregasLogistica.tipEnt}</p>
            </div>
            <div className='col-md-4'>
              <label className='labelInfo'>Responsable de entrega</label>
              <p>{this.props.entregasLogistica.nomUsuaResp}</p>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <label className='labelInfo'>Personal adicional</label>
              <p>{ this.props.personasAdicionales.map((x)=>(
                x.nomUsuAdic
              ))}
              </p>
            </div>
            <div className='col-md-4'>
              <label className='labelInfo'>Entrega con placas
                  </label>
              <p>{this.props.entregasLogistica.tipPlaca === '01' ? 'Si' : 'No'}</p>
            </div>
          </div>
        </div>
        <div className='card card-lg card-plain mb-3'>
          <div className='row'>
            <div className='col-md-4'>
              <label className='labelInfo'>Lugar de entrega</label>
              <p>{this.props.entregasLogistica.lugarEntrega}</p>
            </div>
            <div className='col-md-4'>
              
              {
              this.props.entregasLogistica.tipLugEnt === '2'?(
                <div>
                <label className='labelInfo'>Dirección de entrega</label>
                <p>{this.props.entregasLogistica.dirEntrVehi}</p>
                </div>
              ):(
              <p></p>
              )

                }
            </div>
            <div className='col-md-4'>
              <label className='labelInfo'>Fecha de entrega
                  </label>
              <p><i className='ion-calendar' /> { this.props.entregasLogistica.fecProgramada ? moment(this.props.entregasLogistica.fecProgramada).format('DD/MM/YYYY HH:mm:ss') : '-'}</p>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <label className='labelInfo'>Contacto recepción</label>
              <p>{this.props.entregasLogistica.nomContRece}</p>
            </div>
            <div className='col-md-4'>
              <label className='labelInfo'>Teléfono</label>
              <p>{this.props.entregasLogistica.telContRece}</p>
            </div>
            <div className='col-md-4'>
              <label className='labelInfo'>Email</label>
              <p>{this.props.entregasLogistica.emaContRece}</p>
            </div>
          </div>
        </div>
        <div className='card card-lg card-plain'>
          <label className='labelInfo'>Observaciones</label>
          <p dangerouslySetInnerHTML={this.printcontent(this.props.entregasLogistica.obsEntrVeh)}></p>

        </div>
      </div>
    );
  }
  renderListaHistorial() {
    return (!this.state.historial.historial)?null:
    (this.state.historial.historial.length <= 0 ?null:
      this.state.historial.historial.map((historia, i) => (
        <li key={i} className='card card-plain card-lg fdv-hist-event'>
          <i className='fdv-hist-event-icon ion-android-textsms' />
          <div className='fdv-hist-event-head'>
            <h5 className='fdv-hist-event-title'>{historia.desMotivo}</h5>
            <p className='subInfo'>{historia.usuarioCreacion} el {historia.fechaCreacion ? moment(historia.fechaCreacion).format('DD/MM/YY - HH:mm') : '-'}</p>
          </div>
          <p class="mb-0"><span class="mr-2" dangerouslySetInnerHTML={this.printcontent(historia.observacion)}></span></p>

          {!historia.usuNotiHist?'':(
            <div className='fdv-hist-event-head'>
              <p className='subInfo' >Notificados {historia.usuNotiHist}</p>
            </div>
          )}
        </li>
      ))
    );
  }

  renderHistorial() {
    return (
      <div>
        <header className='fdv-section-head'>
          <h5 className='fdv-section-title'>Observaciones previas</h5>
          <div className='fdv-section-actions'>
            <button className='btn btn-primary btn-sm' show='#coment1' disabled={!IDPROCESO_MCDE} onClick={() => this.clickNuevaObservacion()} >Nueva observación</button>
          </div>
        </header>
        <div className='comment card card-lg card-plain' id='coment1' style={{ display: this.state.display }} >
          <div className='row'>
            <div className='col-sm-6'>
              <div className='form-group'>
                <label className='labelInfo'>Motivo (PNC)*</label>
                <div className='select'>
                  <select className='form-control' value={this.state.optionMotivo} onChange={this.changeSearchOptionMotivo} >
                        <option value=''>Motivo (PNC)</option>
                    {
                      this.props.estadoGeneralMotivoRechazo.map((item, i) =>
                        <option key={i} value={item.id}>{item.descripcion}</option>
                    )}
                  </select>
                  <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
                </div>
                <span className='error' style={{ display: (this.state.optionMotivo === '' && this.state.validarCampo) ? 'block' : 'none' }}>Introduce Motivo (PNC)</span>
              </div>
            </div>
          </div>
          <div className='form-group comment-textarea'>
            <div className='form-group'>
              <label className='labelInfo'>Observación*</label>
              <textarea className='form-control' value={this.state.observacion} onChange={this.onChangeObservacionInput} />
              <span className='error' style={{ display: (this.state.observacion.length === 0 && this.state.validarCampo) ? 'block' : 'none' }}>Introduce Observacion</span>
            </div>
          </div>
          <div className='row form-group'>
            <div className='col-sm-6'>
              <div className='pillSelct'>
                <p className='labelInfo'>Notificar colaborador</p>
                <div className='pillSelct-field'>
                <Autocomplete
                    getItemValue={item => item.idUsuario.toString()}
                    items={this.state.colaboradores}
                    renderItem={(item, isHighlighted) =>
                      <div key={item.idUsuario} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
                        {`${item.apellidos} ${item.nombre}`}
                      </div>
                    }
                    onChange={(e) => {
                      if (e.target.value.length >= 2) {
                        this.traerColaboradores(e.target.value);
                      }
                      if (e.target.value.length === 0) {
                        this.limpiarColaboradores();
                      }
                      this.setState({ colaboradorCaja: e.target.value });
                    }}
                    value={this.state.colaboradorCaja}
                    autoHighlight={this.state.trueComplete}
                    onSelect={(key) => {
                      const tieneColaborador = this.state.colaboradoresSeleccionados.filter(({ id }) => id === key);

                      const name = this.state.colaboradores
                                    .filter(({ idUsuario }) =>
                                      idUsuario.toString() === key)[0].nombre;

                      const apellidos = this.state.colaboradores
                                    .filter(({ idUsuario }) =>
                                      idUsuario.toString() === key)[0].apellidos;
                      const varpersona = { id: key, apellido: `${apellidos} ${name}` };
                      if (tieneColaborador.length < 1) {
                        this.setState({
                          colaboradoresSeleccionados: [...this.state.colaboradoresSeleccionados, varpersona]
                        });
                      }
                      this.setState({colaboradorCaja: ''});
                      this.limpiarColaboradores();
                    }}
                      menuStyle={{
                      position: 'absolute',
                      left: '0',
                      top: '100%',
                      maxHeight: '350px',
                      overflow: 'auto',
                      border: '1px solid #cccccc',
                    }}
                    inputProps={{
                      className: 'form-control awesomplete pillSelct-input',
                    }}
                    wrapperStyle={{
                      position: 'relative',
                      zIndex: '10',
                    }}
                  />
                </div>
                <div className='pillSelct-pills'>
                  {
                          this.state.colaboradoresSeleccionados.map((item, i) =>
                            <label key={i} className='pill pill-cyan pillSelct-pills-item'>{item.apellido}
                              <button
                                type='button'
                                className='pillSelct-delete'
                                onClick={() => this.setState({
                                  colaboradoresSeleccionados: this.state.colaboradoresSeleccionados
                                                                .filter(({ id }) => id !== item.id),
                                })}
                              >
                                <i className='icon ion-close pill-close' />
                              </button>
                            </label>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className='btnActions'>
            <button className='btn btn-secondary' onClick={this.clickCancelar} >Cancelar</button>
            <button className='btn btn-primary' onClick={this.clickComentar} hideparent='.comment'>Comentar</button>
          </div>
        </div>
        <ul>
          {this.renderListaHistorial()}
        </ul>

      </div>
    );
  }

  render() {
    return !this.props.entregasLogistica ? null : (
      <div>
        <div className='modal' id='entrega-detalle' role='dialog' data-backdrop='static' style={{ display: this.props.muestraModalVerDetalle }} >
          <div className='modal-dialog modal-lg modal-noTitle' role='document'>
            <button className='btn btn-sm btn-blue modal-close' data-dismiss='modal' onClick={this.cerrarModalVerDetalle} >Cerrar ventana</button>
            <div className='modal-content'>
              <div className='modal-body'>
                <div className='modalBleed modalBleed-top'>
                  <div className='carCard'>
                    <div className='carCard-firstInfo'>
                      <p className='tag tag-Top tag-green'>{_.capitalize(this.props.tipoProg)}</p>
                      <div className='text-right'>
                        <div className='dropdown kebab' role='group' />
                      </div>
                      <div className='row'>
                        <div className='col-md-5'>
                        <h2 className='h4 mt-0'><span className='bold'>{this.props.entregasLogistica.nomMarca}</span><br /><span>{this.props.entregasLogistica.modelo}</span></h2>
                        </div>
                        <div className='col-md-2'>
                          <p className='labelInfo'>Nº FDV</p>
                          <p>{this.props.entregasLogistica.numFichaVta}</p>
                        </div>
                        <div className='col-md-3'>
                          <p className='labelInfo'>Nº Chasis</p>
                          <p>{this.props.entregasLogistica.numChasis}</p>
                        </div>
                        <div className='col-md-2'>
                          <p className='labelInfo'>Nº Pedido</p>
                          <p>{this.props.entregasLogistica.numPedidoVeh}</p>
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-md-4'>
                          <p className='labelInfo' style={{fontSize:'0.9em',fontWeight:'800'}}>Propietario</p>
                          <p>{this.props.entregasLogistica.desCliente}</p>
                        </div>
                        <div className='col-md-4'>
                          <p className='labelInfo' style={{fontSize:'0.9em',fontWeight:'800'}}>{this.props.entregasLogistica.dni === '' || this.props.entregasLogistica.dni === null ? 'RUC' : 'DNI'} </p>
                          <p>{this.props.entregasLogistica.dni === '' || this.props.entregasLogistica.dni === null ? `${this.props.entregasLogistica.ruc}` : `${this.props.entregasLogistica.dni}`}</p>
                        </div>
                        <div className='col-md-4'>
                          <p className='labelInfo' style={{fontSize:'0.9em',fontWeight:'800'}}>Asesor Comercial </p>
                          <p>{this.props.entregasLogistica.asesorComercial}</p>
                        </div>
                      </div>
                    </div>
                    <div className='carCard-sec'>
                      <div className='row'>
                        <div className='col-sm-4'>
                          <p className='labelInfo'>Área de venta</p>
                          <p>{this.props.entregasLogistica.desAreaVta}</p>
                        </div>
                        <div className='col-sm-2'>
                          <p className='labelInfo'>Familia</p>
                          <p>{this.props.entregasLogistica.desFamiliaVeh}</p>
                        </div>
                        <div className='col-sm-2'>
                          <p className='labelInfo'>Fª C. Comer.</p>
                          <p>{this.props.entregasLogistica.fechaCompEntrega ? moment(this.props.entregasLogistica.fechaCompEntrega).format('DD/MM/YYYY') : '-'}</p>
                        </div>
                        <div className='col-sm-2'>
                          <p className='labelInfo'>Fª C. Logíst.</p>
                          <p>{this.props.entregasLogistica.fechaComLog ? moment(this.props.entregasLogistica.fechaComLog).format('DD/MM/YYYY') : '-'}</p>
                        </div>
                        <div className='col-sm-2'>
                          <p className='labelInfo'>Fª Ent. Placa</p>
                          <p>{this.props.entregasLogistica.fecRecepPlaca ? moment(this.props.entregasLogistica.fecRecepPlaca).format('DD/MM/YYYY') : '-'}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='tabs-hr'>
                    <ul className='tabs' role='tablist'>
                      <li role='presentation' className={`tabs-item ${this.state.isActive === 0 ? 'active' : null}`} >
                        <a className='tabs-item-link' onClick={() => this.setState({ isActive: 0 })} role='tab' aria-controls='infoEntrega' data-toggle='tab'>Información de entrega</a>
                      </li>
                      <li role='presentation' className={`tabs-item ${this.state.isActive === 1 ? 'active' : null}`} >
                        <a className='tabs-item-link' onClick={() => this.setState({ isActive: 1 })} role='tab' aria-controls='historialEntrega' data-toggle='tab'>Historial</a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='tab-content'>
                  <section className={`tab-pane ${this.state.isActive === 0 ? 'active' : null}`} id='infoEntrega'>
                    {this.renderInformacion()}
                  </section>
                  <section className={`tab-pane ${this.state.isActive === 1 ? 'active' : null}`} id='historialEntrega'>
                    {this.renderHistorial()}
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FichaEntregasLogistica/DetalleEntregasLogistica.js